import { render, staticRenderFns } from "./JqueryTable.vue?vue&type=template&id=1e2975f7&"
import script from "./JqueryTable.vue?vue&type=script&lang=js&"
export * from "./JqueryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports